'use client';

import '@ui5/webcomponents/dist/ProgressIndicator.js';
import { ValueState } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * Shows the progress of a process in a graphical way. To indicate the progress, the inside of the component is filled with a color.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-ProgressIndicator)
 */
const ProgressIndicator = withWebComponent('ui5-progress-indicator', ['accessibleName', 'displayValue', 'value', 'valueState'], ['disabled', 'hideValue'], [], []);
ProgressIndicator.displayName = 'ProgressIndicator';
ProgressIndicator.defaultProps = {
  value: 0,
  valueState: ValueState.None
};
export { ProgressIndicator };